import { render, staticRenderFns } from "./CatalogCategoryEdit.vue?vue&type=template&id=ebc05018&"
import script from "./CatalogCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./CatalogCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports